document.addEventListener("DOMContentLoaded", function () {
  const discountDivField = document.getElementById("discount-id");
  const discountCode = discountDivField ? discountDivField?.getAttribute("data-discount") : null;

  if (!discountCode) {
    return;
  }

  // Apply Shopify discount link if not already in URL
  if (!window.location.search.includes("discount=" + discountCode)) {
    fetch(`/discount/${encodeURIComponent(discountCode)}`)
      .then(() => console.log("Shopify discount applied:", discountCode))
      .catch((err) => console.error("Failed to apply discount:", err));
  }

  // Function to apply Hulk discount once available
  function applyHulkDiscount() {
    const hulkDiscountBox = document.querySelector(".discount_code_box");
    const hulkDiscountInput = hulkDiscountBox?.querySelector(".hulkapps_discount_code");
    const hulkApplyButton = hulkDiscountBox?.querySelector(".hulkapps_discount_button");
    const cartOrderTotal = document?.querySelector(".totals__total-value");

    if (hulkDiscountInput) {
      hulkDiscountInput.value = discountCode;
      hulkDiscountInput.dispatchEvent(new Event("input", { bubbles: true }));
      hulkDiscountInput.dispatchEvent(new Event("change", { bubbles: true }));
      // Optionally trigger click if the app requires it
      if (hulkApplyButton) {
        hulkApplyButton.click();
        console.log("Hulk discount applied via button click");
        
      }
      return true;
    }
    return false;
  }

  // Try immediately
  if (!applyHulkDiscount()) {
    // Observe DOM changes until discount box appears
    const observer = new MutationObserver(() => {
      if (applyHulkDiscount()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
});
